import { usePublishedArticles } from "@/hooks/use-articles";
import { useLanguage } from "@/context/LanguageContext";
import { Link } from "react-router-dom";
import { optimizeImageUrl, responsiveSrcSet } from "@/lib/image-utils";

const ArticlesSection = () => {
  const { data: articles = [] } = usePublishedArticles(3);
  const { t } = useLanguage();

  if (articles.length === 0) return null;

  return (
    <div>
      <h2 className="font-display text-2xl md:text-3xl font-bold mb-6">{t("home.articles")}</h2>
      <div className="flex flex-col gap-4">
        {articles.map((article) => (
          <Link
            key={article.id}
            to={`/jaunumi/${article.slug}`}
            className="group flex gap-4 bg-card rounded-xl border border-border shadow-sm hover:shadow-md overflow-hidden transition-all"
          >
            {article.cover_image_url && (
              <div className="w-24 h-24 sm:w-32 sm:h-32 shrink-0 bg-muted overflow-hidden">
                <img
                  src={optimizeImageUrl(article.cover_image_url, { width: 300 })}
                  srcSet={responsiveSrcSet(article.cover_image_url, [150, 300])}
                  sizes="128px"
                  alt={article.title}
                  width={128}
                  height={128}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
            )}
            <div className="py-3 pr-3 flex-1 min-w-0">
              <h3 className="font-display font-semibold text-sm sm:text-base mb-1 group-hover:text-primary transition-colors line-clamp-2">{article.title}</h3>
              {article.excerpt && <p className="text-xs sm:text-sm text-muted-foreground line-clamp-2">{article.excerpt}</p>}
              {article.published_at && (
                <p className="text-xs text-muted-foreground mt-2">{new Date(article.published_at).toLocaleDateString()}</p>
              )}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ArticlesSection;
